import { render, staticRenderFns } from "./StatesHistory.vue?vue&type=template&id=049e3efe"
import script from "./StatesHistory.vue?vue&type=script&lang=js"
export * from "./StatesHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports